import {
    ReturnAddressUploadFailureStatsParam,
    ReturnAddressUploadFailureStatsVo
} from '@servicesTypings/towerRequestV3'

import { companyRequest, towerRequest, drpRequest } from '@/utils/request'
import {
    OrderBaseParam,
    CountOrdersBelowControlPriceUsingGetParams,
    CountOrdersBelowControlPriceVo,
    QueryBelowControlPriceLabelRelationParam,
    QueryBelowControlPriceLabelVo,
    EditAllowSuppliersToSplitOrderParam,
    CountOrdersBySupplierParam,
    CountOrdersBySupplierVo,
    OrderDistributionRemarksAutoSyncParam,
    FindOrdersRequiringRevertParam,
    FindOrdersRequiringRevertVo,
    DistributionNoteParam,
    BatchQueryDistributionNoteVo,
    SaveDistributionNoteParam,
    BatchAddOrUpdateVo,
    QueryDistributionNotesUsingGetParams,
    QueryDistributionNoteVo,
    BatchSaveDistributionNoteParam,
    BatchSaveDistributionNoteVo,
    QueryOwnDistributionNotesUsingGetParams,
    DistributionNote,
    OrderArchiveInfoVo,
    OrderBreakPriceQuestionConfig,
    CountUsingGetParams,
    ErpDrpOrderCount,
    OrderStatisticsCountParam,
    QueryAllowSuppliersToSplitOrderUsingGetParams,
    ExcelImportVo,
    ErpDisOrderParam,
    SettleGenerateStatisticsUsingGetParams,
    OrderSettleRsp,
    GetSettlementStatementOutcomeUsingGetParams,
    SettlementStatementOutcomeVo,
    QuestionVo,
    ErpDisOrderAmt,
    OpenWorkOrderInfo,
    WorkOrderDTO,
    OrderProcessParam,
    OrderProcessingResult,
    ContactSupplierToCheckPriceUsingGetParams,
    UpdateOrderAddressParam,
    AuthCountVo,
    TransformQuestionOrderParam,
    ErpTransformQuestionRsp,
    AddressQuery,
    AddressResp,
    SelfDefQuestionParam,
    OrderToPendingReviewParam,
    ImportGoodsInfoParam,
    UploadReturnAddressParam,
    UploadReturnAddressDTO,
    ImportOrExportTaskResp,
    ImportGoodsInfoTemplateVo,
    OrderSyncOnLineDeliveryFailStatisticsParam,
    OrderSyncOnLineDeliveryFailVo,
    OrderDeliveryFailDetailVO,
    SyncOnLineDeliveryFailCountUsingGetParams,
    SupplyConfigParam,
    BatchExchangeOrderGoodsParam,
    BatchMultiExchangeOrderGoodsResultVO
} from '@servicesTypings/companyRequestV3'
import {
    ChannelRemarkParam,
    DrpRemarkVo,
    SupplierRemarkParam,
    BatchCheckSupplierIsPartnerVo,
    UpdateUnrestrictedInventoryParam,
    MultiSuppliersParam,
    SimplePartnerVo,
    MultiChannelsParam
} from '@servicesTypings/drpRequestV3'
import {
    OrderBriefInfoVo,
    DisInnerOrderListParam,
    ExcelExportVo,
    NicknameDecryptionParam,
    ExchangeOrderGroupVo
} from '@servicesTypings/towerRequestV3'

// 查询分销订单的数量情况
/**
 * 分销订单的数量
 */
export function fetchOrderNumApi(params: CountUsingGetParams): API.Res<ErpDrpOrderCount> {
    return companyRequest.get('/order/count', { params })
}

// 发货快逾期
/**
 * 订单页面数量统计
 */
export function fetchOrderCountApi(data: OrderStatisticsCountParam): API.Res<ErpDrpOrderCount> {
    return companyRequest.post('/order/statistics/status/count', { data })
}

// 联系分销商在【首页】-【通用设定】是否开启了【允许供应商批量拆分订单】
/**
 * 查询是否允许供应商拆分订单
 */
export function queryAllowSuppliersToSplitOrderApi(
    params: QueryAllowSuppliersToSplitOrderUsingGetParams
): API.Res<boolean> {
    return companyRequest.get('/order/config/queryAllowSuppliersToSplitOrder', { params })
}

// 导入结算
/**
 * 导入结算
 */
export function markImport(data: ExcelImportVo): API.Res<ExcelImportVo> {
    return companyRequest.post('/order/mark/import', { data })
}

// 查询审核订单 job 的最后执行时间
export function queryJobLastTime() {
    return companyRequest.get('/order/queryJobLastTime')
}

// 导出结算
/**
 * 导出待结算订单
 */
export function markExport(data: DisInnerOrderListParam): API.Res<ExcelExportVo> {
    return towerRequest.post('/innerOrder/mark/export', { data })
}

// 生成结算单
/**
 * 结算单生成
 */
export function generateSettle(data: ErpDisOrderParam): API.Res<string> {
    return companyRequest.post('/orderSettlement/generate', { data })
}

//  撤销导入结算
/**
 * 导入结算撤销
 */
export function revokeMarkExport(data: ExcelImportVo): API.Res<ExcelImportVo> {
    return companyRequest.post('/order/mark/revoke', { data })
}

//  结算单统计
/**
 * 结算单生成统计
 */
export function generateStatistics(params: SettleGenerateStatisticsUsingGetParams): API.Res<OrderSettleRsp[]> {
    return companyRequest.get('/orderSettlement/generate/statistics', { params })
}

// 结算单查询出账结果
/**
 * 获取结算单出账结果
 */
export function getSettlementStatementOutcome(
    params: GetSettlementStatementOutcomeUsingGetParams
): API.Res<SettlementStatementOutcomeVo> {
    return companyRequest.get('/orderSettlement/getSettlementStatementOutcome', { params })
}

//  获取异常状态
/**
 * 查询异常类型数量
 */
export function getOrderQuestion(data: string): API.Res<QuestionVo> {
    return companyRequest.post('/order/queryQuestion', { data })
}

// 获取订单金额
/**
 * 订单金额
 */
export function orderAmountApi(data: string): API.Res<ErpDisOrderAmt[]> {
    return companyRequest.post('/order/amount', { data })
}

/**
 * 批量查询订单信息
 */
export function orderAmountList(data: OrderBaseParam[]): API.Res<ErpDisOrderAmt[]> {
    return companyRequest.post('/order/amount/list', { data })
}

// 查询分销商备注
/**
 * 查询分销商备注
 */
export function queryChannelRemark(data: ChannelRemarkParam): API.Res<DrpRemarkVo[]> {
    return drpRequest.post('/partner/channel/queryChannelRemark', { data })
}

// 查询供应商备注
/**
 * 查询供应商备注
 */
export function querySupplierRemark(data: SupplierRemarkParam): API.Res<DrpRemarkVo[]> {
    return drpRequest.post('/partner/supplier/querySupplierRemark', { data })
}

// 查询根据单号获取工单信息
/**
 * 根据单号获取工单信息
 */
export function queryPolyWorkOrder(data: OpenWorkOrderInfo): API.Res<WorkOrderDTO[]> {
    return companyRequest.post('/workOrder/getWorkOrderList', { data })
}

// 查询根据单号获取工单信息
/**
 * 订单处理进度
 */
export function orderProcessing(data: OrderProcessParam): API.Res<OrderProcessingResult[]> {
    return companyRequest.post('/order/processing', { data })
}

// 查询根据单号获取工单信息
/**
 * 联系供应商查询价格
 */
export function contactSupplierToCheckPrice(params: ContactSupplierToCheckPriceUsingGetParams): API.Res<string> {
    return companyRequest.get('/order/goods/contactSupplierToCheckPrice', { params })
}

// 批量获取供应商是否合作
/**
 * 批量校验供应商是否已合作
 */
export function batchCheckSupplierIsPartnerApi(data: string): API.Res<BatchCheckSupplierIsPartnerVo[]> {
    return drpRequest.post('/myPartner/batchCheckSupplierIsPartner', { data })
}

// 修改收件人地址
/**
 * 修改订单地址
 */
export function updateOrderAddressApi(data: UpdateOrderAddressParam): API.Res<object> {
    return companyRequest.post('/order/updateOrderAddress', { data })
}

// 解密用的安全校验
/**
 * 检查供应商/分销商侧敏感操作是否授权
 */
export function checkCompanyAuthApi(data: AuthCountVo): API.Res<object> {
    return companyRequest.post('/auth/checkCompanyAuth', { data })
}

//  获取阿里巴巴昵称明文
/**
 * 昵称解密
 */
export function nicknameDecryptionApi(data: NicknameDecryptionParam): API.Res<string> {
    return towerRequest.post('/innerOrder/nicknameDecryption', { data })
}

// 分销订单可转【暂停发货】的异常
/**
 * 订单转异常接口（打单终止发货）
 */
export function transformQuestionOrder(data: TransformQuestionOrderParam): API.Res<ErpTransformQuestionRsp[]> {
    return companyRequest.post('/order/transformQuestionOrder', { data })
}

// 导入地址
/**
 * 导入过滤地址
 */
export function addressImport(data: AddressQuery): API.Res<AddressResp> {
    return companyRequest.post('/address/import', { data })
}

/** 锁单异常 */
export interface LockOrderQuestion {
    /** 异常名称 */
    questionName: string

    /** 异常是否已同步给分销商 */
    hasSyncDistributors: boolean
}

/** 查询锁单异常列表的返回数据 */
export interface QueryLockOrderQuestionsData {
    /** 预定义异常 */
    system: string[]

    /** 自定义异常 */
    custom: string[]

    /** 预定义异常 */
    systemQuestions: LockOrderQuestion[]

    /** 自定义异常 */
    customQuestions: LockOrderQuestion[]
}

// 查询锁定订单时异常列表
export function queryLockOrderQuestions(params: {} = {}) {
    return companyRequest.get('/order/queryLockOrderQuestions', {
        params
    }) as API.Res<QueryLockOrderQuestionsData>
}

// 更新转为异常单的问题
/**
 * 添加/删除/修改自定义异常
 */
export function changeQuestion(data: SelfDefQuestionParam): API.Res<boolean> {
    return companyRequest.post('/order/changeQuestion', { data })
}

/**
 * 将订单异常状态同步到分销商的接口参数
 */
export interface TransmitOrderExceptionParam {
    /** 订单号列表 */
    oidList: string[]

    /** 异常问题描述 */
    questionDesc?: string

    /** 异常问题类型 */
    questionType?: string
}

/**
 * 将订单异常状态同步到分销商
 * @param data
 */
export function transmitOrderException(data: TransmitOrderExceptionParam) {
    return companyRequest.post('/order/operate/syncOrderExceptionsToDistributors', {
        data
    }) as API.Res<{ data: boolean }>
}

// 【待审核】查询不限制库存设置
/**
 * 查询不限制库存设置
 */
export function queryUnrestrictedInventory(): API.Res<boolean> {
    return drpRequest.get('/config/queryUnrestrictedInventory')
}

// 【待审核】修改不限制库存设置
/**
 * 修改不限制库存设置
 */
export function updateUnrestrictedInventory(data: UpdateUnrestrictedInventoryParam): API.Res<object> {
    return drpRequest.post('/config/updateUnrestrictedInventory', { data })
}

// 转成待审核订单
/**
 * 订单转到待审核
 */
export function orderToPendingReview(data: OrderToPendingReviewParam): API.Res<ErpTransformQuestionRsp[]> {
    return companyRequest.post('/order/orderToPendingReview', { data })
}

// 手工下单导入商品
/**
 * 在手工创建订单的时候导入商品的信息
 */
export function orderImportGoodsInfo(data: ImportGoodsInfoParam): API.Res<ImportOrExportTaskResp> {
    return companyRequest.post('/order/goods/importGoodsInfo', { data })
}

// 手工下单导入商品模版
/**
 * 获取导入商品信息模版
 */
export function orderGetImportGoodsInfoTemplate(): API.Res<ImportGoodsInfoTemplateVo> {
    return companyRequest.get('/order/goods/getImportGoodsInfoTemplate')
}

// 查询低于管控价格的订单数量
/**
 * 查询低于管控价格的订单数量
 */
export function countOrdersBelowControlPrice(
    params: CountOrdersBelowControlPriceUsingGetParams
): API.Res<CountOrdersBelowControlPriceVo> {
    return companyRequest.get('/order/list/countOrdersBelowControlPrice', { params })
}

// 查询订单破价标签
/**
 * 查询订单破价标签V2
 */
export function queryBelowControlPriceLabelV2(
    data: QueryBelowControlPriceLabelRelationParam
): API.Res<QueryBelowControlPriceLabelVo> {
    return companyRequest.post('/order/list/queryBelowControlPriceLabelV2', { data })
}

// 修改是否允许供应商拆分订单
/**
 * 修改是否允许供应商拆分订单
 */
export function editAllowSuppliersToSplitOrder(data: EditAllowSuppliersToSplitOrderParam): API.Res<boolean> {
    return companyRequest.post('/order/config/editAllowSuppliersToSplitOrder', { data })
}

// 供销商同步我的分销商是否开通允许供应商拆单开关
/**
 * 供销商同步我的分销商是否开通允许供应商拆单开关
 */
export function syncAllowSplitOrderNum(): API.Res<null> {
    return drpRequest.post('/partner/supplier/syncAllowSplitOrderNum')
}

// 获取推单异常的供应商
export const getSuppliersWithAbnormalPushOrders = () =>
    companyRequest.get('/order/logistics/countExpressDeliveryExceptions')

// 根据供应商维度统计订单数量
/**
 * 根据供应商维度统计订单数量
 */
export function getCountOrdersBySupplier(data: CountOrdersBySupplierParam): API.Res<CountOrdersBySupplierVo> {
    return companyRequest.post('/order/statistics/status/countOrdersBySupplier', { data })
}

// 批量检查订单是否需要撤回推单
/**
 * 批量检查订单是否需要撤回推单
 */
export function findOrdersRequiringRevert(data: FindOrdersRequiringRevertParam): API.Res<FindOrdersRequiringRevertVo> {
    return companyRequest.post('/order/findOrdersRequiringRevert', { data })
}

// 查询供应商备注等信息
/**
 * 查询供应商信息
 */
export function querySupplierForOrder(data: MultiSuppliersParam): API.Res<SimplePartnerVo[]> {
    return drpRequest.post('/partner/channel/querySupplierForOrder', { data })
}

// 查询分销商备注等信息
/**
 * 查询分销商信息
 */
export function queryChannelForOrder(data: MultiChannelsParam): API.Res<SimplePartnerVo[]> {
    return drpRequest.post('/partner/supplier/queryChannelForOrder', { data })
}

// 批量查询供分销备注
/**
 * 批量查询供分销备注
 */
export function batchQueryDistributionNotes(data: DistributionNoteParam): API.Res<BatchQueryDistributionNoteVo[]> {
    return companyRequest.post('/order/list/batchQueryDistributionNotes', { data })
}

// 保存供分销备注
/**
 * 保存供分销备注
 */
export function saveDistributionNote(data: SaveDistributionNoteParam): API.Res<BatchAddOrUpdateVo> {
    return companyRequest.post('/order/operate/saveDistributionNote', { data })
}

// 查询单个订单供分销备注
/**
 * 查询单个订单供分销备注
 */
export function queryDistributionNotes(params: QueryDistributionNotesUsingGetParams): API.Res<QueryDistributionNoteVo> {
    return companyRequest.get('/order/list/queryDistributionNotes', { params })
}

// 是否开启订单供分销备注多级自动同步
/**
 * 是否开启订单供分销备注多级自动同步
 */
export function isOrderDistributionRemarksAutoSyncEnabled(): API.Res<boolean> {
    return companyRequest.get('/order/config/isOrderDistributionRemarksAutoSyncEnabled')
}

// 设置订单供分销备注多级自动同步
/**
 * 设置订单供分销备注多级自动同步
 */
export function setOrderDistributionRemarksAutoSync(data: OrderDistributionRemarksAutoSyncParam): API.Res<boolean> {
    return companyRequest.post('/order/config/setOrderDistributionRemarksAutoSync', { data })
}

// 批量保存供分销备注
/**
 * 批量保存供分销备注
 */
export function batchSaveDistributionNote(data: BatchSaveDistributionNoteParam): API.Res<BatchSaveDistributionNoteVo> {
    return companyRequest.post('/order/operate/batchSaveDistributionNote', { data })
}

// 查询自己的供分销备注
/**
 * 查询自己的供分销备注
 */
export function queryOwnDistributionNotes(params: QueryOwnDistributionNotesUsingGetParams): API.Res<DistributionNote> {
    return companyRequest.get('/order/list/queryOwnDistributionNotes', { params })
}

// 获取打单 有没有归档，和归档月份
/**
 * 查询订单归档信息
 */
export function queryOrderArchiveInfo(): API.Res<OrderArchiveInfoVo> {
    return companyRequest.get('/order/setting/queryOrderArchiveInfo')
}

// 查询破价转异常设置
/**
 * 查询订单破价转异常设置(带异常同步分销商信息)
 */
export function queryBreakPriceQuestionConfig(): API.Res<OrderBreakPriceQuestionConfig> {
    return companyRequest.get('/order/config/queryBreakPriceQuestionConfig')
}

// 修改破价转异常设置
/**
 * 修改订单破价转异常设置
 */
export function updateBreakPriceQuestionConfig(data: OrderBreakPriceQuestionConfig): API.Res<boolean> {
    return companyRequest.post('/order/config/updateBreakPriceQuestionConfig', { data })
}

// 修改破价转异常设置-同步给分销商
/**
 * 修改破价订单异常同步分销商设置
 */
export function updateBreakPriceQuestionSyncDrp(data: OrderBreakPriceQuestionConfig): API.Res<boolean> {
    return companyRequest.post('/order/config/updateBreakPriceQuestionSyncDrp', { data })
}

/**
 * 查询分销订单简要信息 (转换包含中文无法完全转换)
 */
export function queryDisOrderSimpleInfo(data: any): API.Res<OrderBriefInfoVo[]> {
    return towerRequest.post('/innerOrder/queryDisOrderSimpleInfo', { data })
}

/**
 * 获取换货补发订单列表
 */
export function getExchangeOrderListUsingPOST(data: string): API.Res<ExchangeOrderGroupVo[]> {
    return towerRequest.post('/order/getExchangeOrderList', { data })
}

/**
 * 获取订单发货失败明细
 */
export function getOrderDeliveryFailDetailUsingPOST(data: integer[]): API.Res<OrderDeliveryFailDetailVO[]> {
    return companyRequest.post('/order/getOrderDeliveryFailDetail', { data })
}

/**
 * 查询订单上传的退货地址及上传状态
 */
export function getUploadReturnAddressUsingPOST(data: UploadReturnAddressParam): API.Res<UploadReturnAddressDTO[]> {
    return companyRequest.post('/order/list/getUploadReturnAddress', { data })
}
/**
 * 查询订单上传的退货地址及上传状态
 */
export function getOrderReturnAddressApi(params: { orderId: string }): API.Res<UploadReturnAddressDTO> {
    return companyRequest.get('/order/list/getOrderReturnAddress', { params })
}

/**
 * 获取同步线上发货失败统计数量
 */
export function syncOnLineDeliveryFailCountUsingGET(
    params: SyncOnLineDeliveryFailCountUsingGetParams
): API.Res<OrderSyncOnLineDeliveryFailVo> {
    return companyRequest.get('/order/statistics/syncOnLineDeliveryFailCount', { params })
}

/**
 * 根据同步线上发货失败原因获取订单集合
 */
export function getSyncOnLineDeliveryFailByReasonUsingPOST(
    data: OrderSyncOnLineDeliveryFailStatisticsParam
): API.Res<number[]> {
    return companyRequest.post('/order/statistics/getSyncOnLineDeliveryFailOidByReason', { data })
}

/**
 * 查询供销异常同步配置
 */
export function querySupplyExceptionSynConfigUsingGET(): API.Res<boolean> {
    return companyRequest.get('/order/config/querySupplyExceptionSynConfig')
}

/**
 * 修改供销异常同步配置
 */
export function editSupplyExceptionSynConfigUsingPOST(data: SupplyConfigParam): API.Res<boolean> {
    return companyRequest.post('/order/config/editSupplyExceptionSynConfig', { data })
}
/**
 * 统计退货地址上传失败的原因和数量
 */
export function getReturnAddressUploadFailureStats(
    data: ReturnAddressUploadFailureStatsParam
): API.Res<ReturnAddressUploadFailureStatsVo> {
    return towerRequest.post('/order/getReturnAddressUploadFailureStats', { data })
}

/**
 * 更换订单中的商品, 支持 【sku纬度、订单明纬度】｜支持【多换一、一换多】
 */
export function batchMultiExchangeOrderGoods(
    data: BatchExchangeOrderGoodsParam
): API.Res<BatchMultiExchangeOrderGoodsResultVO> {
    return companyRequest.post('/order/operate/batchMultiExchangeOrderGoods', { data })
}
